import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // DÜZELTME 1: Eksik olan i18next import'u

const API_URL = process.env.REACT_APP_API_URL;

const ResetPasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation(); // DÜZELTME 2: t fonksiyonunu tanımla
    
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState(''); // Ekstra güvenlik için parola onayı
    const [message, setMessage] = useState('');
    const [error, setError] = useState(''); // Hata mesajları için ayrı bir state
    const [loading, setLoading] = useState(false); // Yüklenme durumu için state

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Her denemede eski hatayı temizle
        setMessage('');

        // Parola onayı kontrolü
        if (newPassword !== confirmPassword) {
            setError(t('error_passwords_do_not_match'));
            return;
        }

        setLoading(true); // Yüklenmeyi başlat

        try {
            const response = await fetch(`${API_URL}/api/auth/reset-password/${token}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ newPassword })
            });
            const data = await response.json();
            
            if (!response.ok) {
                // Backend'den gelen hata anahtarını kullanarak bir hata fırlat
                throw new Error(data.messageKey || 'error_unknown');
            }
            
            // Başarılı olduğunda
            setMessage(t(data.messageKey || 'success_password_reset'));
            setTimeout(() => navigate('/login'), 3000); // 3 saniye sonra login'e yönlendir

        } catch (err) {
            // --- HATA YÖNETİMİ BAŞLANGICI ---
            console.error("Parola sıfırlama hatası:", err.message);
            // Hata mesajını çevir ve kullanıcıya göster
            const translatedError = t(err.message);
            
            // Eğer çeviri bulunamazsa (anahtarın kendisi dönerse), genel bir hata göster
            if (translatedError === err.message) {
                setError(t('error_server')); 
            } else {
                setError(translatedError);
            }
            // --- HATA YÖNETİMİ SONU ---
        } finally {
            setLoading(false); // Yüklenmeyi bitir
        }
    };
    
    return (
        <div className="auth-page-container">
            <div className="auth-form-card">
                <h2>{t('reset_password_title')}</h2>

                
                {!message ? (
                    <form onSubmit={handleSubmit}>
                        <div className="form-group-auth">
                            <label htmlFor="newPassword">{t('new_password')}</label>
                            <input 
                                type="password" 
                                id="newPassword"
                                value={newPassword} 
                                onChange={e => setNewPassword(e.target.value)} 
                                required 
                                minLength="8"
                            />
                        </div>
                        <div className="form-group-auth">
                            <label htmlFor="confirmPassword">{t('confirm_new_password')}</label>
                            <input 
                                type="password"
                                id="confirmPassword"
                                value={confirmPassword} 
                                onChange={e => setConfirmPassword(e.target.value)} 
                                required
                            />
                        </div>

                        {/* Hata mesajı varsa göster */}
                        {error && <p className="auth-error">{error}</p>}

                        <button type="submit" disabled={loading}>
                            {loading ? t('loading') + '...' : t('reset_password_btn')}
                        </button>
                    </form>
                ) : (
                    <p className="auth-success">{message}</p>
                )}
            </div>
        </div>
    );
};
export default ResetPasswordPage;